import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export const uploadDocument = withNextApi<
  UploadDocumentResponse,
  UploadDocumentParameters
>("/cvp/CvpUploadDocument");

export interface UploadDocumentParameters extends NextApiParams {
  /**
   * fileData: File;
   * filename: string;
   * departmentId: number;
   * documentType: number;
   */
  formData: FormData;
}

export interface UploadDocumentResponse extends BackendResponse {
  item: DocumentSaveResponse;
}

export interface DocumentSaveResponse {
  ok: boolean;
  response: string;
  id_dokumenter: number | null;
  elapsedMilliseconds: number;
}
